import { Box, CheckBox, FormField, Spinner, Text, TextInput, Tip } from 'grommet';
import { CircleInformation } from 'grommet-icons';
import { Controller, useFormContext } from 'react-hook-form';

import { User } from '@/features/admin/types/user';
import { Client } from '@/features/clients';
import { CreateUpdateClientUserFormSchema } from '@/features/clients/models/create-update-client-user-form-schema';

type Props = {
  client: Client;
  user?: User;
}

const CreateUpdateClientUserForm = ({ client, user }: Props) => {
  const form = useFormContext<CreateUpdateClientUserFormSchema>();

  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const featureOptionsCapsule = client.subscription.premiumFeatures.filter(feature => !feature.key.endsWith('_mobile') && feature.key !== 'ai_insights').map(feature => ({
    key: feature.key,
    name: feature.name,
    disabled: !feature.isEnabled
  }));

    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const featureOptionsMobile = client.subscription.premiumFeatures.filter(feature => feature.key.endsWith('_mobile')).map(feature => ({
    key: feature.key,
    name: feature.name,
    disabled: !feature.isEnabled
  }));

  const getEnabledFeatures = (user: User, isMobile = false) => {
    if(isMobile){
          return user?.premiumFeatures
      ?.filter(feature => feature.isEnabled && feature.key.endsWith('_mobile'))
      .map(feature => feature.key);
    }else{
      return user?.premiumFeatures
        ?.filter(feature => feature.isEnabled && !feature.key.endsWith('_mobile'))
        .map(feature => feature.key);
    }
  };

  return (
    <form>
      <Controller
        control={form.control}
        name="name"
        defaultValue={user?.name ?? ''}
        render={({ field, fieldState: { error } }) => (
          <FormField
            required
            name={field.name}
            label="Name"
            error={error?.message}
          >
            <TextInput {...field}/>
          </FormField>
        )}
      />
      <Controller
        control={form.control}
        name="email"
        defaultValue={user?.email ?? ''}
        render={({ field, fieldState: { error } }) => (
          <FormField
            required
            name={field.name}
            label="Email"
            error={error?.message}
          >
            <TextInput {...field}/>
          </FormField>
        )}
      />
      <Controller
        control={form.control}
        name="enabledFeaturesCapsule"
        // @ts-expect-error TS(2345): Argument of type 'User | undefined' is not assigna... Remove this comment to see the full error message
        defaultValue={getEnabledFeatures(user, false) ?? []}
        render={({ field }) => (
          <Box>
            <Text margin={{ vertical: 'small' }} weight="bold">Features (Capsule)</Text>
            <Box gap="small">
              {
                featureOptionsCapsule.map(option => (
                  <Box direction="row" gap="small" align="center" key={option.key}>
                    <CheckBox
                      label={option.name}
                      disabled={option.disabled}
                      value={option.key}
                      checked={field.value.includes(option.key)}
                      onChange={({ target }) => target.checked
                        ? field.onChange([...field.value, target.value])
                        : field.onChange(field.value.filter((val: string) => val !== option.key))
                      }
                    />
                    {option.disabled && (
                      <Tip
                        content={`"${option.name}" is not enabled for this client.`}
                      >
                        <CircleInformation size="small"/>
                      </Tip>
                    )
                    }
                  </Box>
                ))
              }
            </Box>
          </Box>
        )}
      />

      <Controller
        control={form.control}
        name="enabledFeaturesMobile"
        // @ts-expect-error TS(2345): Argument of type 'User | undefined' is not assigna... Remove this comment to see the full error message
        defaultValue={getEnabledFeatures(user, true) ?? []}
        render={({ field }) => (
          <Box>
            <Text margin={{ vertical: 'small' }} weight="bold">Features (Mobile)</Text>
            <Box gap="small">
              {
                featureOptionsMobile.map(option => (
                  <Box direction="row" gap="small" align="center" key={option.key}>
                    <CheckBox
                      label={option.name}
                      disabled={option.disabled}
                      value={option.key}
                      checked={field.value.includes(option.key)}
                      onChange={({ target }) => target.checked
                        ? field.onChange([...field.value, target.value])
                        : field.onChange(field.value.filter((val: string) => val !== option.key))
                      }
                    />
                    {option.disabled && (
                      <Tip
                        content={`"${option.name}" is not enabled for this client.`}
                      >
                        <CircleInformation size="small"/>
                      </Tip>
                    )
                    }
                  </Box>
                ))
              }
            </Box>
          </Box>
        )}
      />
    </form>
  );
};

export default CreateUpdateClientUserForm;
